import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';

import { items } from './content';

const useStyles = makeStyles((theme) => ({
  item: {
    background: theme.palette.primary.main,
    color: 'white',
    padding: '24px 16px',
    textAlign: 'center',
    height: '100%',
    width: '100%',
    borderRadius: 6,
    transition: '0.3s',

    '&:hover': {
      transform: 'scale(1.05)',
    },
  },
  name: {
    fontWeight: 500,
  },
  description: {
    fontSize: 13,
  },
  icon: {
    fontSize: 35,
    marginBottom: 4,
  },
}));

const Actions = () => {
  const classes = useStyles();

  return (
    <Grid container spacing={2}>
      {items.map(({ id, link, icon, title, description }) => (
        <Grid key={id} item xs={12} sm={6} md={3}>
          <a href={link} target='_blank' rel='noopener noreferrer'>
            <div className={classes.item}>
              <Icon classes={{ root: classes.icon }}>{icon}</Icon>
              <Typography className={classes.name}>{title}</Typography>
              <Typography className={classes.description}>{description}</Typography>
            </div>
          </a>
        </Grid>
      ))}
    </Grid>
  );
};

export default Actions;
